import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'

// Get salary structure values
export async function getSalaryStructureValues(userId: string | undefined, currentUser: any) {
  const {token, tenantId} = setupAxios()
  const response = await fetch(`${API_BASE_URL}/${userId}/salary-structure-values`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })

  if (!response.ok) {
    console.error('Error fetching salary structure values:', response.statusText)
    throw new Error('Error fetching salary structure values')
  }

  return await response.json()
}

export async function resetWorkingDays() {
  const { token, tenantId } = setupAxios()
  
  try {
    const response = await fetch(`${API_BASE_URL}/job/working-days`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-tenant-Id': `${tenantId}`,
      },
    })

    if (!response.ok) {
      console.error('Error resetting working days:', response.statusText)
      throw new Error('Error resetting working days')
    }

    return await response.json()
  } catch (error) {
    console.error('Error in resetWorkingDays API:', error)
    throw error
  }
}

// Send payslip email
export async function sendPayslipEmail(emailDto: {sender: User; subject?: string; body?: string}) {
  const {token, tenantId} = setupAxios()
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'X-tenant-Id': `${tenantId}`,
  }

  try {
    const response = await fetch(`${API_BASE_URL}/salary-structure-values/send-payslip`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(emailDto),
    })
    return await response.json()
  } catch (error) {
    console.error('Error sending payslip email:', error)
    throw new Error('Failed to send payslip email')
  }
}

// Export payslip
export async function exportPayslip(userId: string | undefined) {
  const { token, tenantId } = setupAxios();
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'X-tenant-Id': `${tenantId}`,
  };

  try {
    const response = await fetch(
      `${API_BASE_URL}/salary-structure-values/export-payslip/${userId}`,
      {
        method: 'GET',
        headers: headers,
      }
    );

    if (!response.ok) {
      console.error('Response not OK:', response.status, response.statusText);
      throw new Error('Failed to export payslip');
    }

    const contentType = response.headers.get('Content-Type');

    if (contentType !== 'application/pdf') {
      console.error('Expected PDF but got:', contentType);
      throw new Error('Invalid content type for PDF');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'payslip.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    console.error('Error exporting payslip:', error);
    throw new Error('Failed to export payslip');
  }
}

